import { NgModule } from '@angular/core';
import { ActionReducer, StoreModule } from '@ngrx/store';
import { StateSlice } from '../state-slice';
import { reducer } from './drivers-reducer';
import { initialDriversState } from './drivers-state';
import { combineReducers, entityMetaReducer } from '@core/utils/state';
import { EffectsModule } from '@ngrx/effects';
import { DriversEffects } from './drivers-effects';

@NgModule({
    imports: [
        StoreModule.forFeature(StateSlice.DRIVERS, (reducer as ActionReducer<any, any>), {
            initialState: initialDriversState,
            metaReducers: [entityMetaReducer],
            reducerFactory: combineReducers
        }),
        EffectsModule.forFeature([ DriversEffects ])
    ],
    declarations: []
})
export class DriversStateModule {}
